import MuiAppBar from '@mui/material/AppBar'
import { styled, Toolbar } from '@mui/material'

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  color: theme.colors.black,
  // boxShadow: 'none',
  background: theme.colors.whiteColor_6,
  backdropFilter: 'saturate(200%) blur(10px)',
  boxShadow: `inset 0 0 1px 1px ${theme.colors.headerShadow},0 20px 27px 0 ${theme.colors.black_05} !important`,
  ...(open && {
    width: `calc(100% - ${theme.drawerWidth}px)`,
    marginLeft: `${theme.drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}))

export const StyledToolbar = styled(Toolbar)({
  display: 'flex',
  justifyContent: 'space-between'
})
